import { mapActions, mapGetters, mapState } from 'vuex';
import loaderMixin from '@/mixins/loader';
import marketContract from '@/components/market/market-contract/market-contract.vue';
import marketListItemV2 from '@/components/market/v2/market-list-item-v2/market-list-item-v2.vue';
import collapsiblePanel from '@/components/collapsible-panel/collapsible-panel.vue';

export default {
  mixins: [
    loaderMixin,
  ],
  components: {
    collapsiblePanel,
    marketContract,
    marketListItem: marketListItemV2,
  },
  props: {
    market: {
      type: Object,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.loaderAdd();
    this.getRelatedMarkets(this.market.marketId)
      .then(() => this.loaderRemove())
      .catch(() => this.loaderRemove());
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    ...mapState('market', ['related']),
    show() {
      return this.isLoading || this.related.length > 0;
    },
  },
  methods: {
    ...mapActions('market', ['getRelatedMarkets', 'clearRelatedMarkets']),
  },
  beforeDestroy() {
    this.clearRelatedMarkets();
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-related/market-related.js